import React, { Fragment } from 'react'
import { bool, func } from 'prop-types'
import styled from 'styled-components'
import { rem } from 'polished'
import { Flex, Box } from 'rebass'
import { Image, Text } from 'rebass'

import { Container, media } from '../../../utils/style'
import buildImageUrl from '../../../../lib/media-url-maker'

import LinkRounded from '../../LinkRounded'

const Content = styled(Flex)`
  position: relative;
  background: white;
  line-height: 1.8;
  overflow-y: scroll;
  height: 92vh;
  text-align: left;
  font-weight: ${(props) => props.theme.weights[0]};
  ${media.LargeScreenUp`
  height: auto;
  `};
  img {
    ${media.LargeScreenUp`
    float: right;
  `};
  }
`

const Annotation = styled(({ theme, left, bottom, full, width, ...rest }) => (
  <Box {...rest} />
))`
  font-size: ${(props) => rem(props.theme.fontSizes[1])};
  line-height: 1.5;
  width: 100%;
  ${media.LargeScreenUp`
  text-align: center;
  float: left;
  position: ${(props) => (props.full ? 'absolute' : 'relative')};
  left: ${(props) => props.left};
  bottom: ${(props) => props.bottom};
  width: ${(props) => rem(props.width)};
  `};
  strong {
    font-size: ${(props) => rem(props.theme.fontSizes[2])};
    color: ${(props) => props.theme.colors.blue};
    display: block;
    margin-bottom: 5px;
  }
`

const Diagram = styled(Box)`
  position: relative;
`

const Features = styled(Box)`
  text-align: left;
  strong {
    display: block;
    ${media.LargeScreenUp`
    margin-left: -15px;
    `};
    margin-bottom: 10px;
    color: ${(props) => props.theme.colors.blue};
  }
`

const OrderedList = styled.ol`
  list-style: none;
  text-align: left;
  margin: 0 5%;
  ${media.LargeScreenUp`
  margin: 0 5% 0 0;
  `};
  counter-reset: li;
  li {
    counter-increment: li;
  }
  li::before {
    content: counter(li);
    color: ${(props) => props.theme.colors.blue};
    display: inline-block;
    width: 1em;
    margin-left: -1.5em;
    margin-right: 0.8em;
    text-align: right;
    direction: rtl;
    font-weight: ${(props) => props.theme.weights[1]};
  }
`

const ActionContainer = styled.div`
  position: relative;
  margin-top: 32px;
  ${media.LargeScreenUp`
    left: -15px;
  `};

  a,
  button {
    color: ${(props) => props.theme.colors.white};
  }
`

const ActionContainerAlt = styled.div`
  text-align: center;
  width: 100%;
  margin-top: 16px;

  a,
  button {
    background: transparent;
    border: 0;
  }
`

const VideoContainer = styled.div`
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  overflow: hidden;
  position: relative;
  background-color: ${(props) => props.theme.colors.grey_op10};

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

const HP = ({ isVideoVisible, onVideoToggle }) => (
  <Content flexWrap="wrap" px={'8.333%'} pt={45} pb={[65]} width={1}>
    {!isVideoVisible && (
      <Fragment>
        <Box width={1}>
          <Container maxWidth={['100%', null, '85%']} pb={45}>
            <Text center>
              Hire purchase gives you the power to choose the car you want with
              flexible repayment terms from 12 to 60 months. It’s Simple and
              Hassle free financing. Our no-nonsense, flexible finance plan is
              tailored just for you to keep costs low and affordable.
            </Text>
          </Container>
        </Box>
        <Features width={[1, null, 6 / 12]}>
          <strong>Key Features:</strong>
          <OrderedList>
            <li>0% deposit may be available - subject to status</li>
            <li>Deposit can be made in cash or p/x your current car</li>
            <li>Flexible payment options over 1 to 5 years</li>
            <li>Fixed Interest Rate</li>
            <li>You own the car after final payment</li>
          </OrderedList>
          <ActionContainer>
            <LinkRounded onClick={onVideoToggle}>Watch video</LinkRounded>
          </ActionContainer>
        </Features>
        <Diagram width={[1, null, 6 / 12]} pb={[85, null, 0]}>
          <Image
            src={buildImageUrl({
              publicId: 'diagram-what-is-pcp_2x'
            })}
            width={'100%'}
            mt={[35, null, 0]}
            mb={[40, null, 15]}
            mx={['auto', 0]}
          />
          <Annotation bottom={0} left={'2%'} width={150} pb={[20, null, 0]}>
            <strong>Deposit</strong>
            Typically 10% of the vehicle price (more if you like)
          </Annotation>
          <Annotation
            bottom={0}
            left={'50%'}
            full
            width={150}
            pb={[20, null, 0]}
          >
            <strong>Amount to finance</strong>
            Divided into any choice of 12 - 60 fixed monthly payments
          </Annotation>
        </Diagram>
      </Fragment>
    )}

    {isVideoVisible && (
      <Box width={1}>
        <Container maxWidth={['100%', null, '85%']}>
          <VideoContainer>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/lTGV6t28sN0"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </VideoContainer>
        </Container>
        <ActionContainerAlt>
          <button onClick={onVideoToggle}>Back to description</button>
        </ActionContainerAlt>
      </Box>
    )}
  </Content>
)

HP.propTypes = {
  isVideoVisible: bool,
  onVideoToggle: func
}

export default HP
